export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-4P5Q8TREXS";

export const META_PIXEL_ID =
  process.env.REACT_APP_META_PIXEL_ID || "1453712623483219";

export const TIKTOK_PIXEL_ID =
  process.env.REACT_APP_TIKTOK_PIXEL_ID || "DACIQ2JC77UC8FLJJ280";

export const LINKEDIN_PARTNER_ID =
  process.env.REACT_APP_LINKEDIN_PARTNER_ID || "9655802";
